import React, { useEffect, useState } from "react";
import Layout from "Components/Layout";
import PermissionClasses from "Pages/Settings/Permissions.module.css";
import {
    NotificationSettings,
    NotificationSettingsUpdate,
} from "Services/ServiceRequest";
import Swal from "sweetalert2";
import Loader from "Components/Loader/Loader";
import Subloader from "Components/Loader/subload/loader";
function Permissions() {
    const [subLoad, setSubLoad] = useState(false);
    const [Permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(true);

    const GetRequests = async (Level) => {
        // setLoading(true);
        try {
            const response = await NotificationSettings(Level);

            if (response?.data?.Status === 1) {
                setPermissions(
                    Object.entries(response?.data)
                        .filter(([key]) => key !== "Status")
                        .map(([key, value]) => ({
                            name: key,
                            permissions: value,
                        }))
                );
            } else {
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.log("err");
            Swal.fire({
                title: "Error",
                text: "Something went wrong please try again",
                icon: "error",
            });
        }
    };

    useEffect(() => {
        GetRequests();
    }, []);

    const permissionHandler = async (e, ID) => {
        setSubLoad(true);
        let body = {
            NPId: ID,
            status: e.target.checked ? 1 : 0,
        };
        try {
            const response = await NotificationSettingsUpdate(body);

            if (response?.data?.Status === 1) {
                Swal.fire({
                    title: "Success",
                    text: response?.data?.Message,
                    icon: "success",
                });
            }
            setSubLoad(false);
        } catch (err) {
            setSubLoad(false);
            console.log("err");
            Swal.fire({
                title: "Error",
                text: "Something went wrong please try again",
                icon: "error",
            });
        }
    };

    return (
        <Layout Active={"settings"} title={"Settings"} showBackButton={false}>
            {subLoad && <Subloader />}
            <div className={PermissionClasses["Container"]}>
                <div className={PermissionClasses["Sub_wrapper"]}>
                    <h3>Settings</h3>
                    <Loader loading={loading}>
                        <div
                            className={PermissionClasses["Permission_wrapper"]}>
                            {Permissions?.map((permissionLoop) => (
                                <div
                                    className={PermissionClasses["Permission"]}>
                                    <h4 className={PermissionClasses["head"]}>
                                        {permissionLoop.name}
                                    </h4>
                                    <div>
                                        {permissionLoop?.permissions?.map(
                                            (sectionsLoop) => (
                                                <div
                                                    className={
                                                        PermissionClasses[
                                                            "Section_wrapper"
                                                        ]
                                                    }>
                                                    <div
                                                        className={
                                                            PermissionClasses[
                                                                "SubSection"
                                                            ]
                                                        }>
                                                        <div
                                                            className={
                                                                PermissionClasses[
                                                                    "user_permission"
                                                                ]
                                                            }>
                                                            <input
                                                                type="checkbox"
                                                                id={
                                                                    sectionsLoop?.NPId
                                                                }
                                                                defaultChecked={
                                                                    sectionsLoop?.status ==
                                                                    1
                                                                        ? true
                                                                        : false
                                                                }
                                                                onChange={(e) =>
                                                                    permissionHandler(
                                                                        e,
                                                                        sectionsLoop?.NPId
                                                                    )
                                                                }
                                                            />
                                                            <label
                                                                htmlFor={
                                                                    sectionsLoop?.NPId
                                                                }>
                                                                {
                                                                    sectionsLoop?.permissionName
                                                                }
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Loader>
                </div>
            </div>
        </Layout>
    );
}

export default Permissions;
